const indexItems = [
  { label: '动作电影', count: '3,280部', icon: 'ri-sword-line' },
  { label: '科幻电影', count: '1,856部', icon: 'ri-rocket-line' },
  { label: '悬疑推理', count: '2,140部', icon: 'ri-search-eye-line' },
  { label: '古装剧集', count: '1,520部', icon: 'ri-ancient-gate-line' },
  { label: '都市情感', count: '2,890部', icon: 'ri-heart-line' },
  { label: '纪录片', count: '1,960部', icon: 'ri-earth-line' },
  { label: '动画动漫', count: '2,340部', icon: 'ri-movie-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
            分类导航
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            影视导航
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            按类型快速定位你想看的影视内容，每个分类都有丰富的选择
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#media"
              className="group flex flex-col items-center gap-2 p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/60 transition-all hover:-translate-y-1 hover:border-primary-200 cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{item.label}</span>
              <span className="text-xs text-foreground-400">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}